<!-- 竞猜规则弹窗 游戏币 -->
<template>
<el-dialog
    class="ball-style"
    :visible.sync="status"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    >
    <div class="ball-cup-container">
        <div class="title-text">竞猜规则</div>
        <div class="tag"><img :src="require('../assets/happy.png')" alt="" height="65"></div>
        <div class="close" @click="closeHandler"><img :src="require('../assets/close.png')" alt="" height="33"></div>
        <div class="rule-cont">
            <div class="rule-item"><div class="txt"><strong>用户使用游戏币参与足球竞猜</strong></div></div>
            <div class="rule-item">
          
                <div class="cont">1、</div>
                <div class="flex-cont">
                    <div class="txt">每场比赛有3种状态，“投注中”、“待揭晓”和“已结束”：   </div>
                    <div class="txt">投注中：在截止时间前（也就是球赛开始前），用户可以对同一场比赛多次投注；</div>
                    <div class="txt">待揭晓：球赛进行中，用户不可以进行投注；</div>
                    <div class="txt">已结束：球赛结果已出，用户不可以进行投注，已投注用户等待系统结算游戏币。 </div>
                </div>
            </div>
            <div class="rule-item">
             
                <div class="cont">2、</div>
                <div class="flex-cont">
                    <div class="txt">投注须知：</div>
                    <div class="txt">每场比赛开始前，用户选定1场比赛，使用游戏币对主队在全场90分钟（含伤停补时，不含加时赛和点球大战）的 “主胜”、“平”、“客胜”结果进行投注（单次只能投注一个赛果）。</div>
                    <div class="txt"> 例如：曼联（主队）VS利物浦（客队）</div>
                    <div>
                        <table class="example">
                        <thead>
                            <tr>
                                <td>比赛结果</td>
                                <td>开奖结果</td>
                                <td>中奖情况</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>3:0</td>
                                <td>主胜</td>
                                <td>选择“主队胜”的中奖</td>
                            </tr>
                            <tr>
                                <td>1:1</td>
                                <td>平</td>
                                <td>选择“平局”的中奖</td>
                            </tr>
                            <tr>
                                <td>0:2</td>
                                <td>客胜</td>
                                <td>选择“客胜”的中奖</td>
                            </tr>

                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
            <div class="rule-item">
              
                <div class="cont">3、</div>
                <div class="flex-cont">
                    <div class="txt">游戏币胜负结算</div>
                    <div class="txt">竞猜获胜用户按照每场比赛胜平负对应的赔率，赢得游戏币奖励；竞猜失败的用户则被系统自动扣除投注的游戏币。用户可在活动页面上方“我的游戏币”-"查看明细"中了解游戏币的流水详细。</div>
                </div>
            
            </div>
        </div>
        

    </div>
    <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span> -->
</el-dialog>
</template>
<script>
export default {
    name :'GuessingRules',
    props:['status'],
    data(){
        return {}
    },
    methods:{
        closeHandler(){
            this.$emit('update:status',false)
        }

    }
}
</script>
<style lang="less" scoped>
.ball-style{
    /deep/.el-dialog{width:700px; background: none;}
    /deep/.el-dialog__header{display: none;}
    /deep/.el-dialog__body{
        padding: 0;
    }
}
@media screen and (max-width:768px){
    .ball-style{

        /deep/.el-dialog{width:90%; }
    }
}

.ball-cup-container{
    background: url(../assets/dialog-bg.png) no-repeat right top #ff4400; background-size: 100%; padding:20px 25px; position: relative; border-radius: 10px;
    .title-text{font-size: 20px; line-height: 40px; color: #fff; font-weight: 600; margin-bottom: 10px;}
    .tag{position: absolute; right: 75px; top: 5px;}
    .close{position: absolute; right: 25px; top: 15px; cursor: pointer;}
}

.rule-cont{
    padding: 20px; background: #fff; border-radius: 10px; 
    .rule-item{
        display: flex; font-size: 16px; line-height: 30px; color: #353535;
        .li-ico{padding-top: 3px; margin-right: 3px;}
    }
}
.example{
    border-left: 1px solid #eee; border-top: 1px solid #eee; border-spacing: 0;
    td{
        border-right: 1px solid #eee; border-bottom: 1px solid #eee; padding: 5px;
    }
}
@media screen and (max-width:768px){
    .ball-cup-container{padding: 20px 10px; }
    .rule-cont{padding: 10px;max-height: 360px; overflow: auto;}
}
</style>